import mergeConfig from 'coact/config/mergeConfig'

import autoSelect from './editPage/autoSelect.js'

import schema from './schema.js'
import saveAndPrintInvoice from './editPage/saveAndPrintInvoiceForEventCashier.js'
import editPagePageConfig from './editPage/pageConfig.js'
import listPagePageConfig from './listPage/pageConfig.js'

const config = {
  title: '特賣會結帳',
  schema,
  edit: editPagePageConfig,
  list: listPagePageConfig,
}

const eventConfig = {
  edit: {
    effect: {
      autoSelect: autoSelect({ pricebookKey: '特賣會價', warehouseKey: 'HH' }),
      saveAndPrintInvoice,
    },
  },
}

export default mergeConfig(config, eventConfig)
